<script lang="ts" setup>
    const props = defineProps<{
        isFlipped?: boolean;
        isMatched: boolean;
        isMismatched?: boolean;
        backgroundImage: StoryblokAsset;
        product: MemoryCardStoryblok;
        index?: number;
    }>();
</script>
<template>
    <button
        class="memory-card"
        data-testid="memory-card"
        :data-memory-card-index="props.index"
        :class="{ matched: props.isMatched || false, mismatched: (props.isMismatched && props.isFlipped) || false }"
    >
        <div
            class="memory-card-inner"
            :class="{ flipped: props.isFlipped }"
        >
            <div class="memory-card-front">
                <transition name="fade">
                    <StoryblokImage
                        draggable="false"
                        :media="props.backgroundImage"
                        type="memoryCard"
                        :alt="props.backgroundImage.alt ? props.backgroundImage.alt : ''"
                    />
                </transition>
            </div>
            <div class="memory-card-back">
                <transition name="fade">
                    <div
                        v-if="props.isFlipped && props.product.ProductImage"
                        data-testid="memory-card-product-image"
                    >
                        <StoryblokImage
                            draggable="false"
                            :media="props.product.ProductImage"
                            type="memoryCard"
                            :alt="props.product.ProductImage.alt ? props.product.ProductImage.alt : ''"
                        />
                    </div>
                </transition>
                <transition name="fade">
                    <p
                        v-if="props.isFlipped"
                        class="memory-card-text"
                    >
                        {{ props.product.ProductTitle }}
                    </p>
                </transition>
            </div>
        </div>
    </button>
</template>
<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/memory-game/memory-card.scss';
</style>
